import { motion } from "framer-motion";
import { Reveal } from "@/lib/reveal";
import { IMAGES } from "@/lib/site";
import { useLanguage } from "@/context/LanguageContext";

export const Gallery = () => {
  const { t } = useLanguage();

  return (
    <section id="gallery" data-testid="gallery" className="py-24 md:py-32 bg-card border-y border-border">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal className="overline font-bold tracking-[0.2em]">{t.gallery.overline}</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
                {t.gallery.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="max-w-md">
            <p className="text-base sm:text-lg text-foreground/80 font-medium leading-relaxed">
              {t.gallery.desc}
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-2 md:gap-3">
          {IMAGES.gallery.map((g, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 1.06 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-sm border border-border ${g.span}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 p-4 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity bg-gradient-to-t from-foreground/70 to-transparent">
                {g.alt}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
